import backend, {PAYMENT_API} from 'utils/backend/server/api_library';

const loadClientPaymentPlan = (clientRn) => {
  const url = `${PAYMENT_API}/payment/plan/client/${clientRn}`;
  return backend.get(url);
};


const updateClientHourlyRate = (clientRn, hourlyRate) => {
  const body = {
    hourlyRate,
  };
  const url = `${PAYMENT_API}/payment/plan/client/${clientRn}/hourly`;
  return backend.post(url, body);
};

const updateClientStripeId = (clientRn, stripeCustomerId) => {
  const body = {
    stripeCustomerId,
  };
  const url = `${PAYMENT_API}/payment/plan/client/${clientRn}/stripe_customer_id`;
  return backend.post(url, body);
};

export default {
  loadClientPaymentPlan: loadClientPaymentPlan,
  updateClientHourlyRate: updateClientHourlyRate,
  updateClientStripeId: updateClientStripeId,
};
